import { Injectable } from '@angular/core';

import { flatMap } from 'rxjs/operators';
import { User } from '../models/usuario.model';

@Injectable()
export class Data {
  getUsuario(): User {
    return JSON.parse(localStorage.getItem('usuario'));
  }
  setUsuario(usuario: User) {
    localStorage.setItem('usuario', JSON.stringify(usuario));
  }

  constructor() {}
}
